<template>
  <div class="apprecruit1">
    <div class="recruit1">
      <div class="recruit1_box">
        <div class="title_box">
          动漫表情包
        </div>
        <div class="recruit1_label">
          <div class="label_item1" @click="Btnitem(1)">
            <p class="itemName">Pico猫</p>
            <img src="../assets/images/pico10.png" alt="" />
            <p class="name">10元/组 <a>点击查看</a></p>
          </div>
         
          <div class="label_item1" @click="Btnitem(5)">
            <p class="itemName">鸡哥-圣诞版</p>
            <img src="../assets/images/pico50.png" alt="" />
            <p class="name">10元/组 <a>点击查看</a></p>
          </div>
          <!-- <div class="label_item1">
            <img src="../assets/images/pico15.png" alt="" />
          </div> -->
        </div>
      </div>
      <div class="bask2" @click="bask" v-if="baskBg">
        <h1>
          仅可查看表情部分内容，需登录付费后下载高清表情，点击付费下载按钮进行付费。
        </h1>
        <div class="images1" v-if="active == 1">
          <img src="../assets/images/pico10.png" alt="" />
          <img src="../assets/images/pico11.png" alt="" />
          <img src="../assets/images/pico12.png" alt="" />
          <img src="../assets/images/pico13.png" alt="" />
          <img src="../assets/images/pico14.png" alt="" />
          <img src="../assets/images/pico15.png" alt="" />
        </div>
        <div class="images1" v-if="active == 2">
          <img src="../assets/images/pico20.png" alt="" />
          <img src="../assets/images/pico21.png" alt="" />
          <img src="../assets/images/pico22.png" alt="" />
          <img src="../assets/images/pico23.png" alt="" />
          <img src="../assets/images/pico24.png" alt="" />
        </div>
        <div class="images1" v-if="active == 3">
          <img src="../assets/images/pico30.png" alt="" />
          <img src="../assets/images/pico31.png" alt="" />
          <img src="../assets/images/pico32.png" alt="" />
          <img src="../assets/images/pico33.png" alt="" />
          <img src="../assets/images/pico34.png" alt="" />
          <img src="../assets/images/pico35.png" alt="" />
        </div>
        <div class="images1" v-if="active == 4">
          <img src="../assets/images/pico40.png" alt="" />
          <img src="../assets/images/pico41.png" alt="" />
          <img src="../assets/images/pico42.png" alt="" />
          <img src="../assets/images/pico43.png" alt="" />
          <img src="../assets/images/pico44.png" alt="" />
          <img src="../assets/images/pico45.png" alt="" />
          <img src="../assets/images/pico46.png" alt="" />
          <img src="../assets/images/pico47.png" alt="" />
          <img src="../assets/images/pico48.png" alt="" />
          <img src="../assets/images/pico49.png" alt="" />
          <img src="../assets/images/pico411.png" alt="" />
          <img src="../assets/images/pico412.png" alt="" />
          <img src="../assets/images/pico413.png" alt="" />
        </div>
        <div class="images1" v-if="active == 5">
          <img src="../assets/images/pico50.png" alt="" />
          <img src="../assets/images/pico51.png" alt="" />
          <img src="../assets/images/pico52.png" alt="" />
          <img src="../assets/images/pico53.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: 5,
      baskBg: false
    };
  },
  methods: {
    Btnitem(num) {
      console.log(num);
      this.active = num;
      this.baskBg = true;
    },
    bask() {
      this.baskBg = !this.baskBg;
    }
  }
};
</script>
<style lang="less">
.apprecruit1 {
  .header {
    background-color: #f7f7f7;
  }
  .recruit1 {
    width: 100%;
    height: 100%;
    background: #f7f7f7;
    overflow: hidden;
    margin-top: 50px;
    ::after {
      position: fixed;
      content: "";
      width: 130px;
      height: 130px;
      background-size: contain;
      // background-image: url(../assets/images/pic_Yello@2x.png);   background-repeat: no-repeat;
      background-position: center center;
      top: 40px;
      left: 0;
    }
    .sector {
      width: 50%;
      position: fixed;
    }
    .recruit1_box {
      min-width: 100%;
      height: 100%;
      margin: 0 auto;
      .title_box {
        width: 100%;
        text-align: center;
        margin: 20px 0;
        .recruit1_title {
          width: 60%;
          vertical-align: middle;
          margin-top: 30px;
        }
        .recruit1_text {
          width: 60%;
          font-size: 14px;
          display: inline-block;
          line-height: 18px;
          vertical-align: middle;
          margin-top: 10px;
        }
      }
      .recruit1_label {
        margin: 0 auto;
        .label_item {
          width: 44%;
          margin: 10px 3%;
          float: left;
          img {
            width: 100%;
          }
        }
        .label_item1 {
          width: 50%;
          padding: 10px;
          box-sizing: border-box;
          text-align: center;
          float: left;
          margin-top: 10px;
          img {
            width: 100%;
            border: 1px solid rgb(255, 239, 0);
            box-sizing: border-box;
            border-radius: 10px;
            padding: 4px;
            margin: 10px 0;
          }
        }
      }
      .recruit1_label1 {
        margin: 0 auto;
        .label_item1 {
          width: 80%;
          margin: 2px 10%;
          float: left;
          img {
            width: 100%;
          }
        }
      }
    }
  }
}
.bask2 {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  h1 {
    color: #ffffff;
    font-size: 24px;
    text-align: center;
    margin-top: 20px;
  }
  .images1 {
    width: 100%;
    img {
      width: 20%;
      margin: 4px;
      border: 1px solid #ffffff;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}
@media screen and (min-width: 750px) {
  .apprecruit1 {
    .recruit1 .recruit1_box .title_box .recruit1_title {
      width: 50%;
      margin-top: 50px;
      margin-bottom: 20px;
    }
    .recruit1 .recruit1_box .title_box .recruit1_text {
      width: 60%;
      font-size: 28px;
      display: inline-block;
      line-height: 40px;
      vertical-align: middle;
      margin-top: 10px;
    }
    .recruit1 {
      .recruit1_box {
        .recruit1_label1 {
          .label_item1 {
            width: 44%;
            margin: 10px 3%;
            float: left;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/appseries.vue